import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  font-size: 48px;
  color: ${beam.font.primary};
  align-items: start;
  flex-direction: column;
  justify-content: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
`;
